import React from "react";
import ReactHtmlParser from "react-html-parser";

export const fdtWithdrawalRestrictedCountries = (
  blockedCountries: string
) => `Withdrawals from the following countries won't be accepted and will be returned by our partner bank:
      ${blockedCountries}, Crimea Region, Donetsk & Luhansk. `;

export const fdtConsiderStableCoins = ReactHtmlParser(
  `Please reach out to <a target="_blank" href="/support">BF Support</a> if needed. We apologise for the inconvenience.`
);

export const fdtDepositRestrictedCountries = (blockedCountries: string) => (
  <>
    <span>
      Deposits from the following countries won't be accepted and will be
      returned by our partner bank: {blockedCountries}, Crimea Region, Donetsk &
      Luhansk.
    </span>
    <br />
  </>
);
